import React from 'react'
import { Link } from 'react-router-dom'
import './../Form.css'


const Button = props => {
    const {id, type, label, href, action, variant} = props;
    return (
        <div className="form-element">
            <div className="form-button">
                {href &&
                <Link to={href}>
                    <button className={variant} id={id} type={type}>{label}</button>
                </Link>}
                {!href && <button className={variant} id={id} type={type} onClick={action}>{label}</button>}
            </div>
        </div>
    )
}
export default Button
